import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';
import { standardAsyncConnect } from 'utils/asyncConnectWrapper';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';

import { Link } from 'react-router';
import { resultHref } from 'modules/HorseRacing/utils';
import { sortBy, isEmpty } from 'lodash';

import { localDateShortDescriptive,isoDate } from 'utils/LocalDateTimeHelper';
import ordinalSuffix from "utils/OrdinalSuffix";
import MyStableUnauthenticatedUser from '../components/MyStableUnauthenticatedUser';

import { userServiceLayoutConnect } from 'modules/Common/reducers/userService';
import { loadResults } from '../reducers/myStableResults';


require('./MyStableResults.scss');

@standardAsyncConnect([
  userServiceLayoutConnect({
    then: ({getState, dispatch}) => dispatch(loadResults(getState().common.userService.subscriptions)),
    state: state => ({auth: state.common.auth, myStableResults: state.horseRacing.myStableResults})
  })
])

@catchLifeCycleErrors
export default class MyStableResults extends Component {
  static propTypes = {
    isLoggedIn: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    myStableResults: PropTypes.object
  }


  render() {
    if (!this.props.isLoggedIn()) {
      return <MyStableUnauthenticatedUser/>
    }
    const { props: { myStableResults: { results } } } = this;

    return (
      <section className="my-stable-results-container">
        <MetaDataWrapper title="Next Results"/>
        <h3 className="my-stable-subtitle section-title">Your Results</h3>
        {
          !isEmpty(results) ?
            Object.keys(results).sort().map((entry, i) =>
              <MyStableResultsTable key={`${entry}-${i}`} label={localDateShortDescriptive(entry)} results={results[entry]}/>
            )
          :
          <div className="my-stable-selection-none">
            <span>None of your selections have any results.</span>
          </div>

        }
      </section>
    );
  }
}

function extractRaceProps(race, matchType) {
  const matchingRide = race.rides[0];
  const parts = [['Horse', matchingRide.horse.name || 'Not Specified'],
          ['Jockey', matchingRide.jockey.name || 'Not Specified'],
          ['Trainer', matchingRide.trainer.name || 'Not Specified']]

  const matchIndexMap = {'H': 0, 'J': 1, 'T': 2};

  return {
    mainName: parts.splice(matchIndexMap[matchType], 1)[0][1],
    matchType: matchType,
    raceName: race.race_summary.name,
    parts
  };
}

function hrefData(race) {
  const {
    race_summary: {
      date,
      course_name,
      name,
      race_summary_reference: {
        id
      }
    }
  } = race;

  return {
    course_name,
    date: isoDate(date),
    race_id: id,
    race_name: name
  };
}

function MyStableResultsTable({label, results}) {
  const sortedRes = sortBy(results, o => o.race.race_summary.time);

  return (
    <section className="my-stable-results">
      <div className="my-stable-section-header">
        <span className="my-stable-section-header-key">{label}</span>
        <span className="my-stable-section-header-remove"></span>
      </div>
      <div className="">
        <table className="my-stable-table">
          <tbody>
            {sortedRes.map(({matched, race, matchType}) =>
              <tr key={`${matched}-${race.race_summary.race_summary_reference.id}-${race.rides[0].horse.name}-${matchType}`}>
                <td className="my-stable-results-time">
                  {race.race_summary.time}
                </td>
                <td className="my-stable-results-details">
                  <Link to={resultHref(hrefData(race))}>
                    <MyStableResultMatchRows {...extractRaceProps(race, matchType)} />
                  </Link>
                </td>
                <td className="my-stable-results-pos">
                  {ordinalSuffix(race.rides[0].amended_position || race.rides[0].finish_position) || 'N/A'}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  )
}

MyStableResultsTable.propTypes = {
  label: PropTypes.string.isRequired,
  results: PropTypes.arrayOf(PropTypes.shape({
    matched: PropTypes.number.isRequired,
    race: PropTypes.shape({
      race_summary: PropTypes.shape({
        race_summary_reference: PropTypes.shape({
          id: PropTypes.number
        })
      })
    })
  }))
}

function MyStableResultMatchRows(props) {
  return (
    <span>
      <p className="who-where">
        <span className="my-stable-results-details-horse">{props.mainName}</span>
        { ' (' + props.matchType + ') ' }
        {!!props.raceName && ' - '+ props.raceName}
      </p>
      <p className="others">
        {props.parts.map(part => part.join(': ')).join(', ')}
      </p>
   </span>
  )
}

MyStableResultMatchRows.propTypes = {
  mainName: PropTypes.string.isRequired,
  raceName: PropTypes.string,
  matchType: PropTypes.string.isRequired,
  parts: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)).isRequired
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/MyStableResults.js